import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { isUnauthorizedError } from '../utils/orderFormat';
import { loginState } from '../utils/authRedirect';

export function useAccountSession() {
  const { isAuthenticated, customerName, logout } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [unauthorized, setUnauthorized] = useState(false);

  useEffect(() => {
    if (!isAuthenticated && !unauthorized) navigate('/login', { replace: true, state: loginState(location) });
  }, [isAuthenticated, unauthorized, navigate, location]);

  const expireSession = useCallback(() => {
    setUnauthorized(true);
    logout();
  }, [logout]);

  useEffect(() => {
    window.addEventListener('unauthorized', expireSession);
    return () => window.removeEventListener('unauthorized', expireSession);
  }, [expireSession]);

  const handleRequestError = useCallback(
    (error: unknown) => {
      if (isUnauthorizedError(error)) {
        expireSession();
        return true;
      }
      return false;
    },
    [expireSession]
  );

  const signOut = useCallback(() => {
    logout();
    navigate('/login');
  }, [logout, navigate]);

  return { isAuthenticated, customerName, unauthorized, handleRequestError, signOut };
}
